import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { withStyles } from "@material-ui/core/styles";
import {Popover, PopoverInteractionKind, Position  } from "@blueprintjs/core";
import Loader from '../../utils/loader'

const defaultToolbarSelectStyles = {
    iconButton: {
        color: '#18A9E3'
    },
    iconContainer: {
        marginRight: "24px",
    },
    inverseIcon: {
        transform: "rotate(90deg)",
    },
};

class CustomToolbarSelect extends React.Component {
    handleClickInverseSelection = () => {
        const nextSelectedRows = this.props.displayData.reduce((nextSelectedRows, _, index) => {
            if (!this.props.selectedRows.data.find(selectedRow => selectedRow.index === index)) {
                nextSelectedRows.push(index);
            }

            return nextSelectedRows;
        }, []);

        this.props.setSelectedRows(nextSelectedRows);
    };

    handleClickDeselectAll = () => {
        this.props.setSelectedRows([]);
    };

    handleClickBlockSelected = () => {
        // console.log(`block users with dataIndexes: ${this.props.selectedRows.data.map(row => row.dataIndex)}`);
    };

    componentDidMount(){
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.iconContainer} style={{margin: '12px 0'}}>
                <Popover
                    interactionKind={PopoverInteractionKind.CLICK}
                   
                    position={Position.BOTTOM}
                    className='bulk-actions'
                    isOpen={this.props.bulkIsOpen}
                >
                    <Tooltip title={"Assign Tag"}>
                        <IconButton className={classes.iconButton}>
                            <LocalOfferIcon className={classes.icon} />
                        </IconButton>
                    </Tooltip>
                    <div className='bulk-actions-content padding-10'>
                        <span
                            onClick={() => this.props.handleCreateAddTag()}
                            className='create-new-tag-btn'>Create new{this.props.createTagLoader ? <i style={{marginLeft: 5}} className='fa fa-spin fa-spinner'/> : ''}</span>
                        <input
                            autoFocus={true}
                            type="text" id='find-tag' className='input-create-new-tag'
                            onChange={e => this.props.handleTagSearch(e.currentTarget.value)}
                            placeholder='Create or find tag'/>
                        <p className='m-s-t m-sm-b'>Choose a tag:</p>

                        <div className="tag-container-large">

                            {

                                this.props.bulkLoader ?
                                    <Loader/>
                                    :
                                    this.props.bulkTags && this.props.bulkTags.length ?
                                        this.props.searchedBulkTags.map(
                                            tag =>
                                                <div
                                                    key={tag.id}
                                                    className='tag-checkbox'>
                                                    {tag.subsCount === 0 ?
                                                        <span
                                                            onClick={(e) => this.props.handleBulkAction(e, tag.id)}
                                                            className='bulk-checkbox clear'>

                                                                </span> :
                                                        tag.subsCount !== 0 && tag.subsCount < this.props.checkedContacts.length ?
                                                            <span
                                                                onClick={e => this.props.handleBulkAction(e, tag.id)}
                                                                className='bulk-checkbox half'>-
                                                                                </span> :
                                                            <span
                                                                onClick={e => this.props.handleBulkAction(e, tag.id)}
                                                                className='bulk-checkbox full'>
                                                                    </span>
                                                    }
                                                    <p className='bulk-tagname'> {tag.name}</p>
                                                </div>
                                        ) : ''
                            }

                        </div>
                    </div>
                </Popover>
                <Tooltip title={"Delete selected"}>
                    <IconButton className={classes.iconButton} onClick={this.props.handleDeleteContacts}>
                        <DeleteIcon className={classes.icon} />
                    </IconButton>
                </Tooltip>
                {
                    this.props.allContactsChecked ?
                        <Tooltip title={"Delete All contacts"}>
                            <IconButton className={classes.iconButton} onClick={this.props.handleDeleteAllContacts}>
                                <DeleteForeverIcon className={classes.icon} />
                            </IconButton>
                        </Tooltip>
                        :
                        ''
                }

            </div>
        );
    }
}

export default withStyles(defaultToolbarSelectStyles, { name: "CustomToolbarSelect" })(CustomToolbarSelect);